<template>
  <grid
    class="dashboard-wrapper"
    dashboard-wrapper
    v-once
    flat
    wrap="wrap"
    :rwd="{ compact: 'stack' }"
  >
    <grid-item
      class="dashboard-item dashboard-user"
      dashboard-item
      dashboard-item-user
      size="1/2"
      :rwd="{ compact: '1/1' }"
    >
      <SectionWrapper class="whiteframe shadowframe">
        <router-link
          class="dashboard-item-link"
          :to="{ name: pages.PROFILE_USER }"
        >
          <Avatar class="image-icon" />
          <p>
            <b>PROFILE</b><br />
            <small>Update your Nickname and Avatar</small>
          </p>
        </router-link>
      </SectionWrapper>
    </grid-item>
    <grid-item
      class="dashboard-item dashboard-security"
      dashboard-item
      dashboard-item-login
      size="1/2"
      :rwd="{ compact: '1/1' }"
    >
      <SectionWrapper class="whiteframe shadowframe">
        <router-link
          class="dashboard-item-link"
          :to="{ name: pages.PROFILE_LOGIN }"
        >
          <img src="/static/images/icons/security.png" class="image-icon" />
          <p>
            <b>LOGIN</b><br />
            <small>Update your E-mail, Password, Two-Factor</small>
          </p>
        </router-link>
      </SectionWrapper>
    </grid-item>
    <grid-item
      class="dashboard-item dashboard-billing"
      dashboard-item
      dashboard-item-billing
      size="1/2"
      :rwd="{ compact: '1/1' }"
    >
      <SectionWrapper class="whiteframe shadowframe">
        <router-link
          class="dashboard-item-link"
          :to="{ name: pages.PROFILE_BILLING }"
        >
          <img src="/static/images/icons/billing.png" class="image-icon" />
          <p>
            <b>BILLING</b><br />
            <small>Update your Billing info</small>
          </p>
        </router-link>
      </SectionWrapper>
    </grid-item>
    <grid-item
      class="dashboard-item dashboard-newsletters"
      dashboard-item
      dashboard-item-subscriptions
      size="1/2"
      :rwd="{ compact: '1/1' }"
    >
      <SectionWrapper class="whiteframe shadowframe">
        <router-link
          class="dashboard-item-link"
          :to="{ name: pages.PROFILE_NEWSLETTERS }"
        >
          <img src="/static/images/icons/newsletters.png" class="image-icon" />
          <p>
            <b>NEWSLETTERS</b><br />
            <small>Update your E-mail preferences</small>
          </p>
        </router-link>
      </SectionWrapper>
    </grid-item>
    <!--<grid-item class="dashboard-item dashboard-game-servers" size="1/2" :rwd="{compact: '1/1'}">-->
    <!--<SectionWrapper class="whiteframe shadowframe">-->
    <!--<router-link class="dashboard-item-link" :to="{ name: pages.PROFILE_SERVER_MANAGEMENT }">-->
    <!--<img src="/static/images/icons/server-management.png" class="image-icon">-->
    <!--<p>-->
    <!--<b>GAME SERVER TOKENS</b><br>-->
    <!--<small>Manage game server login tokens</small>-->
    <!--</p>-->
    <!--</router-link>-->
    <!--</SectionWrapper>-->
    <!--</grid-item>-->
  </grid>
</template>

<script>
import Avatar from "@/components/partials/profile/Avatar";

export default {
  name: "profile-dashboard",
  components: { Avatar }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.whiteframe {
  margin: 0.5em;
  border: 1px solid transparent;
  transition: border-color 0.5s;

  &:hover {
    border-color: rgb(62, 91, 144);
  }
}

.dashboard-item {
  .dashboard-item-link {
    display: block;
    text-decoration: none;
    color: #333;
  }
}

.image-icon {
  max-width: 100%;
  height: auto;
  margin-bottom: 1em;
}
</style>
